import { useCallback } from "react";

const bulletPoint = "•";

export const useBulletList = ({ id, isBulletList, textAreaRef, value, disabled, setValue, onKeyDown,  }) => {
  const handleFocus = useCallback(() => {
    if (isBulletList && (!value || value?.length === 0)) {
      setValue(`${bulletPoint} `);
    }
  }, [isBulletList, value, id]);

  const handleSetValue = useCallback(
    (newValue) => {
      if (isBulletList && !value.startsWith(bulletPoint)) {
        setValue(`${bulletPoint} ` + newValue);
      } else {
        setValue(newValue);
      }
    },
    [isBulletList, value, id]
  );

  const handleEnterKeyDown = (e) => {
    if (isBulletList && e.key === "Enter" && !disabled) {
      e.preventDefault();
      setValue((prev) => prev + `\n${bulletPoint} `);

      if (textAreaRef?.current) {
        setImmediate(() => {
          textAreaRef.current.scrollTop = textAreaRef.current.scrollHeight;
        });
      }
    }

    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  return { handleFocus, handleSetValue, handleEnterKeyDown };
};
